module.exports = {
  "config-version": "",
  "projectId": "movistar-prosegur-alarmas",
  "appSegment": "particulares",
  "basePath": "/particulares/movistar-prosegur-alarmas",
  "devPublicPath": "",
  "devCrossOriginLoading": "use-credentials",
  "qaCrossOriginLoading": "use-credentials",
  "qaPublicPath": "https://qa.cms.col.movistar.es",
  "prodPublicPath": "https://prod.cms.col.movistar.es",
  "prod18PublicPath": "https://ssr.col.movistar.es",
  "prodCrossOriginLoading": false,
  "projectSegment": "particulares",
  "versionJs": "movistar-prosegur-alarmas-17-01-143",
  "forceImgFromCDNOnDev": true,
  "imgProdUrlForDev": "https://prod.cms.col.movistar.es/particulares/movistar-prosegur-alarmas/_next/static/images/",
  "headerFooterPathOnError": "/particulares/404"
}